<template>
  <el-dialog
    title="Scan Attendance"
    width="70%"
    top="2em"
    :fullscreen="$mq === 'xs'"
    :visible.sync="dialogVisible"
  >
    <el-form v-if="value"
    @submit.native.prevent="save">
      <el-form-item label="ID">
        <el-input v-model="textFieldValue" @input="textChanged" size="large"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">Submit</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<style scoped>
.mg {
  max-width: 12em;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import {mapFields} from "vuex-map-fields";
export default {
    props: {value: {required: true}},
    data() {
        return {dialogVisible: false, textFieldValue: ""};
    },
    computed: {...mapFields(["terms"])},
    methods: {
        save() {
            this.axios
                .post(
                    "/api/v1/attendance/storebyuid",
                    {
                        uid: this.textFieldValue,
                        event_id: this.value.o_id,
                        attendance_type: 4
                    },
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then(() => {
                    this.textFieldValue = "";
                    this.$message({
                        showClose: true,
                        message: "Attendance record added",
                        type: "success"
                    });
                })
                .catch((err) => {
                    this.textFieldValue = "";
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: "User UID not found.",
                        type: "error"
                    });
                });
        },
        close() {
            this.dialogVisible = false;
            this.textFieldValue = "";
            this.$emit("close");
        },
        open() {
            this.dialogVisible = true;
            this.textFieldValue = "";
        },
        textChanged(value) {
            // SAFARI HATES REGEX [this.textFieldValue] = value.match(/(?<=;)(.*)(?==)/gm);
            var idx = value.indexOf(';');
            //If ; is not in string idx = -1 and the below still works
            this.textFieldValue = value.substring(idx+1, idx+10);
        }

    }
};
</script>
